import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Select,
  Space,
  Table,
  Tooltip,
  Typography,
} from "antd";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { CloseOutlined, DeleteOutlined } from "@ant-design/icons";
import axios from "axios";
import { NotificationInfo, UserInfo } from "../../../context";
import NewSaveRawProcessUnsave from "./NewSaveRawProcessUnsave";

const NewAddRawProcess = ({ close, getRawProcessList }) => {
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);
  const { rerunNotif } = useContext(NotificationInfo);
  const [productRawList, setProductRawList] = useState({
    data: [],
    ready: false,
  });
  const [rawProcessUnsaveList, setRawProcessUnsaveList] = useState({
    data: [],
    ready: false,
  });

  const [specProductRawStandard, setSpecProductRawStandard] = useState({
    data: [],
    ready: false,
  });
  const [specProductInfo, setSpecProductInfo] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const scroll = {};
  const [loading, setLoading] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [form] = Form.useForm();
  const [selectedData, setSelectedData] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [inputedQuantityConversion, setInputedQuantityConversion] = useState(0);
  const [inputedMultipleQty, setInputedMultipleQty] = useState(1);
  const [selectedNote, setSelectedNote] = useState("");
  // const [selectedRawID, setSelectedRawID] = useState("");
  const localRawID = localStorage.getItem("BBMSRawID");
  const [checked, setChecked] = useState(false);

  const columns = [
    {
      title: "Product",
      dataIndex: ["processunsaverawproduct", "product"],
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Description",
      dataIndex: ["processunsaverawproduct", "description"],
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Unit",
      dataIndex: ["processunsaverawproduct", "rawproductsuserunit", "unit"],
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      align: "right",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      render: (text) => (
        <p>
          <Tooltip title="Delete">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setDeleteDialog(true);
              }}
              icon={<DeleteOutlined />}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getRawProductList = useCallback(() => {
    var params = { user_id: userData.data.id, is_production: 1 };
    axios
      .get("user/commissary/raw-product-list", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setProductRawList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  const getRawProcessUnsaveList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/commissary/raw-process-unsave-list", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setRawProcessUnsaveList({ data, ready: true });
        if (data.length > 0) {
          setInputedMultipleQty(data[0].multiple);
          setChecked(true);
        } else {
          setInputedMultipleQty(1);
          setChecked(false);
        }
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  const handleFetchRawStandards = (rawID) => {
    var params = {
      raw_id: rawID,
      user_id: userData.data.id,
    };
    setSpecProductRawStandard({ data: [], ready: false });
    axios
      .get("user/commissary/spec-product-raw-standard", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setSpecProductRawStandard({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  const handleFetchProduct = (rawID) => {
    var params = {
      raw_id: rawID,
      user_id: userData.data.id,
    };
    setSpecProductInfo({ data: [], ready: false });
    axios
      .get("user/commissary/spec-product-info", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setSpecProductInfo({ data, ready: true });
        form.setFieldsValue({
          conversion: 0,
        });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  useEffect(() => {
    getRawProductList();
    getRawProcessUnsaveList();
    if (localRawID !== null) {
      handleFetchRawStandards(localRawID);
    }
    // eslint-disable-next-line
  }, [getRawProductList, getRawProcessUnsaveList, localRawID]);

  const handleOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setDeleteDialog(false);
      setConfirmLoading(false);
      handleDeleteProductInDelivery();
    }, 2000);
  };

  const handleDeleteProductInDelivery = () => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("id", selectedData !== null ? selectedData.id : "");
    setLoadings(true);
    axios
      .post("user/commissary/delete-product-in-raw-process", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Delete product successfully.");
          setTimeout(() => {
            setLoadings(false);
            getRawProcessUnsaveList();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  const handleAddProductToUnsave = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append(
      "total_quantity",
      checked
        ? parseInt(inputedQuantityConversion) * parseInt(inputedMultipleQty)
        : parseInt(inputedQuantityConversion)
    );
    formdata.append("multiple", checked ? parseInt(inputedMultipleQty) : 1);
    formdata.append("note", selectedNote);

    for (const name in values) {
      formdata.append(name, values[name]);
    }
    var error = [];
    if (
      parseInt(inputedQuantityConversion) >
      parseInt(specProductInfo.ready && specProductInfo.data[0].quantity)
    ) {
      error = "error";
      rerunNotif("error", "Invalid quantity input.");
    }
    if (error.length > 0) {
      console.log("Something went wrong.");
    } else {
      setLoadings(true);
      setLoading(true);
      axios
        .post("user/commissary/new-raw-process-product-unsave", formdata)
        .then((response) => {
          const data = response.data;
          if (data === "product-exist") {
            rerunNotif("error", "Product already added!");
            setTimeout(() => {
              form.setFieldsValue({
                conversion: 0,
              });
              setLoadings(false);
              setLoading(false);
            }, 1000);
          }
          if (data === "success") {
            rerunNotif("success", "Adding product successfully.");
            setTimeout(() => {
              form.setFieldsValue({
                conversion: 0,
              });
              setLoadings(false);
              setLoading(false);
              getRawProcessUnsaveList();
            }, 1000);
          }
        })
        .catch((error) => {
          setLoadings(false);
        });
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 5,
        }}
      >
        <div style={{ flexGrow: 1 }} />
        <Button type="primary" icon={<CloseOutlined />} onClick={() => close()}>
          Close
        </Button>
      </div>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={24} md={16}>
          <div style={{ border: "1px solid #e5e5e5", borderRadius: 5 }}>
            <div style={{ padding: 10 }}>
              <div style={{ marginBottom: 10 }}>
                <Typography.Title level={4}>Creating Product</Typography.Title>
              </div>
              <div style={{ overflowX: "auto" }}>
                <Table
                  {...tableProps}
                  pagination={{
                    position: ["bottomCenter"],
                  }}
                  columns={tableColumns}
                  dataSource={
                    rawProcessUnsaveList.data.length > 0
                      ? rawProcessUnsaveList.data
                      : []
                  }
                  scroll={scroll}
                  rowKey={(record) => record.id}
                />
                <div
                  style={{
                    display:
                      rawProcessUnsaveList.data.length > 0 ? "flex" : "none",
                  }}
                >
                  <div style={{ flexGrow: 1 }} />
                  <div>
                    <Button
                      type="primary"
                      loading={loadings}
                      onClick={() => setOpenDrawer(true)}
                      //   disabled={specProductRawStandard}
                      disabled={
                        rawProcessUnsaveList.data.length !==
                        specProductRawStandard.data.length
                      }
                    >
                      {loadings ? "Loading" : "Create"}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <div style={{ border: "1px solid #e5e5e5", borderRadius: 5 }}>
            <div style={{ padding: 10 }}>
              <div style={{ marginBottom: 10 }}>
                <Typography.Title level={4}>
                  Add All Raw Materials Needed
                </Typography.Title>
              </div>
              <div>
                <Form
                  form={form}
                  layout="vertical"
                  name="basic"
                  initialValues={{
                    product_production: localRawID !== null ? localRawID : "",
                  }}
                  onFinish={handleAddProductToUnsave}
                  autoComplete="off"
                >
                  <Space
                    direction="vertical"
                    style={{
                      width: "100%",
                      margin: 0,
                    }}
                  >
                    <Checkbox
                      checked={checked}
                      disabled={rawProcessUnsaveList.data.length > 0}
                      onChange={(e) => setChecked(e.target.checked)}
                    >
                      Allow multiple production process
                    </Checkbox>

                    {checked && (
                      <Form.Item
                        // name=""
                        label="Multiple of?"
                        rules={[
                          {
                            required: true,
                            message: "Required",
                          },
                        ]}
                      >
                        <InputNumber
                          min={1}
                          max={999999999999}
                          value={inputedMultipleQty}
                          size="large"
                          style={{ width: "100%" }}
                          step="1"
                          onChange={(value) => {
                            if (value === null) {
                              setInputedMultipleQty(1);
                            } else {
                              setInputedMultipleQty(value);
                            }
                          }}
                          disabled={rawProcessUnsaveList.data.length > 0}
                        />
                      </Form.Item>
                    )}

                    <Form.Item
                      name="product_production"
                      label="Product for Production"
                      rules={[
                        {
                          required: true,
                          message: "Required",
                        },
                      ]}
                    >
                      <Select
                        placeholder="Select product for production"
                        onChange={(e) => {
                          localStorage.setItem("BBMSRawID", e);
                          handleFetchRawStandards(e);
                          form.setFieldsValue({
                            product: "",
                          });
                        }}
                        size="large"
                        showSearch
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {productRawList.data.length > 0 &&
                          productRawList.data.map((data, index) => (
                            <Select.Option
                              value={data.raw_id}
                              key={index}
                              disabled={
                                rawProcessUnsaveList.data.length > 0
                                  ? localRawID === data.raw_id
                                    ? false
                                    : true
                                  : false
                              }
                            >
                              {data.product}
                            </Select.Option>
                          ))}
                      </Select>
                    </Form.Item>

                    {specProductRawStandard.ready &&
                      specProductRawStandard.data.length > 0 && (
                        <>
                          <Form.Item
                            name="product"
                            label="Products used in Production"
                            rules={[
                              {
                                required: true,
                                message: "Required",
                              },
                            ]}
                          >
                            <Select
                              placeholder="Select product used in production"
                              onChange={(e, w) => {
                                setInputedQuantityConversion(
                                  parseInt(w.children[2])
                                );
                                setSelectedNote(
                                  specProductRawStandard.data[0].note
                                );
                                form.setFieldsValue({
                                  delivered_quantity: w.children[2],
                                });
                                handleFetchProduct(e);
                              }}
                              size="large"
                              showSearch
                              filterOption={(input, option) =>
                                option.props.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                            >
                              {specProductRawStandard.data.length > 0 ? (
                                specProductRawStandard.data.map(
                                  (data, index) => (
                                    <Select.Option
                                      value={data.raw_id}
                                      key={index}
                                    >
                                      {data.rawprodstandardrawproduct.product}
                                      {" - "}
                                      {data.quantity}
                                    </Select.Option>
                                  )
                                )
                              ) : (
                                <Select.Option value="">
                                  No raw product found!
                                </Select.Option>
                              )}
                            </Select>
                          </Form.Item>

                          {specProductInfo.ready && specProductInfo.data && (
                            <>
                              <Form.Item label="Unit">
                                <Input
                                  placeholder="Set unit"
                                  size="large"
                                  defaultValue={
                                    specProductInfo.data[0].rawproductsuserunit
                                      .unit
                                  }
                                  disabled
                                />
                              </Form.Item>

                              <Form.Item
                                name="delivered_quantity"
                                label="Production Quantity"
                                rules={[
                                  {
                                    required: true,
                                    message: "Required",
                                  },
                                ]}
                              >
                                <InputNumber
                                  min={1}
                                  max={999999999999}
                                  value={inputedQuantityConversion}
                                  size="large"
                                  style={{ width: "100%" }}
                                  step="1"
                                  onChange={(value) => {
                                    if (value === null) {
                                      setInputedQuantityConversion(0);
                                    } else {
                                      setInputedQuantityConversion(value);
                                    }
                                  }}
                                  disabled
                                />
                              </Form.Item>

                              <Typography style={{ fontWeight: "bold" }}>
                                Total Quantity :{" "}
                                {parseInt(inputedQuantityConversion)}{" "}
                                {
                                  specProductInfo.data[0].rawproductsuserunit
                                    .unit
                                }
                                {checked
                                  ? ` * ${inputedMultipleQty} = ${
                                      parseInt(inputedQuantityConversion) *
                                      parseInt(inputedMultipleQty)
                                    }`
                                  : ""}
                              </Typography>
                              <Typography style={{ fontWeight: "bold" }}>
                                Available Quantity :{" "}
                                {specProductInfo.data[0].quantity}{" "}
                                {
                                  specProductInfo.data[0].rawproductsuserunit
                                    .unit
                                }
                              </Typography>
                            </>
                          )}
                        </>
                      )}
                  </Space>

                  <Form.Item style={{ marginTop: "20px" }}>
                    <Button
                      type="primary"
                      loading={loadings}
                      htmlType="submit"
                      style={{ width: "100%", borderRadius: "20px" }}
                      disabled={
                        parseInt(inputedQuantityConversion) === 0 ||
                        (checked
                          ? parseInt(inputedQuantityConversion) *
                            parseInt(inputedMultipleQty)
                          : parseInt(inputedQuantityConversion)) >
                          parseInt(
                            specProductInfo.data.length > 0 &&
                              specProductInfo.data[0].quantity
                          )
                      }
                    >
                      {loadings ? "Loading" : "Add"}
                    </Button>
                  </Form.Item>
                </Form>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      {openDrawer && (
        <NewSaveRawProcessUnsave
          open={openDrawer}
          closeOriginalTab={() => close()}
          close={() => setOpenDrawer(false)}
          setLoading={setLoading}
          getRawProcessUnsaveList={() => getRawProcessUnsaveList()}
          getRawProcessList={() => getRawProcessList()}
          localRawID={localRawID}
          note={
            rawProcessUnsaveList.data.length > 0
              ? rawProcessUnsaveList.data[0].note
              : ""
          }
          multiple={inputedMultipleQty}
          checked={checked}
        />
      )}

      <Modal
        title="Are you sure to delete this product?"
        open={deleteDialog}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => setDeleteDialog(false)}
      />
    </>
  );
};

export default NewAddRawProcess;
